import { Namespace, useT } from "@racoon/i18n";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@racoon/ui";
import { ConnectProto } from "@racoon/api";

interface LabelSelectProps {
  id: string;
  options: ConnectProto.OrganizationLabel[];
  /** A label id, "0" for none («Не указано»). */
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

/** Picks one of an organization's labels (a pickup location or customer type), or none. */
export const LabelSelect = ({ id, options, value, onChange, disabled }: LabelSelectProps) => {
  const t = useT();
  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger id={id}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="0">{t(Namespace.Settings, "organizationLabels.undefined")}</SelectItem>
        {options.map((label) => (
          <SelectItem key={label.id.toString()} value={label.id.toString()}>
            {label.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
